import React from "react";
import { Helmet } from "react-helmet";
// import img1 from "../../../assets/islam/img-title/กฎหมายมรดก.png";
import "./posts-islam.css"

const คำนวณ = () => {
  const TITLE = "วิธีการคำนวณมรดกอิสลาม";

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div className="content">
        <br></br>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;วิธีการคำนวณมรดกอิสลาม มีความสำคัญและจำเป็นอย่างมาก เนื่องจากมีเงื่อนไขและกฎเกณฑ์ของทายาทแต่ละรายแตกต่างกันออกไป 
          และยังมีตัวเลขเศษส่วน และการบวกเศษส่วนเข้ามาเกี่ยวข้องด้วย
          
          {/* 1 */}
          <div>
            <h2 id="initial-header">1. ขั้นตอน และวิธีการแบ่งมรดกให้แก่ทายาท</h2>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;การคำนวณหาส่วนแบ่งของมรดกในศาสนาอิสลาม มี 6 ขั้นตอนดังนี้
              <ul className=" list-decimal ml-16 mb-3">
                <li>พิจารณาจำนวนทายาทของเจ้ามรดก และนำมาแยกออกเป็น 2 กลุ่ม คือ กลุ่มทายาทผู้ที่มีสิทธิรับมรดก และกลุ่มทายาทผู้ที่ไม่มีสิทธิรับมรดก <a className="text-indigo-700 underline" href="/islam/2">อ่านต่อได้ที่นี่</a>{" "}</li>
                <li>ในกลุ่มของทายาทผู้ที่มีสิทธิรับมรดก ให้นำทายาทในกลุ่มผู้ที่มีสิทธิรับมรดกมากำหนดสัดส่วนของทายาทเพื่อให้ทราบอัตราส่วนของทายาทในแต่ละคน ซึ่งผู้ที่มีสิทธิได้รับมรดกนั้นสามารถแบ่งออกเป็น 11 ประเภท <a className="text-indigo-700 underline" href="/islam/2">อ่านต่อได้ที่นี่</a>{" "}</li>
                <li>เมื่อแยกประเภททายาทของเจ้ามรดก และกำหนดสัดส่วนเรียบร้อยแล้ว ให้นำส่วนของสัดส่วนของทายาทในข้อที่ 2 ทั้งหมดที่ได้มาทำการการหา ค.ร.น.
                  <p className="ml-8">
                      <span className=" text-blue-600">
                        -- เช่น  ผู้หญิงคนหนึ่งเสียชีวิตโดยมีทายาทที่มีสิทธิรับมรดกดังนี้ มารดา, หลานสาว (บุตรหญิงของหลานผู้ตาย) หนึ่งคน และพี่สาวร่วมแต่บิดาหนึ่งคน พร้อมกับเงินมรดกจำนวน 600,000 บาท จากขั้นตอนที่ 2 ให้กำหนดสัดส่วนในแต่ละทายาทก่อน โดยในตัวอย่างนี้ทายาทของผู้ตายมีอัตราส่วนที่ได้รับดังนี้
                        <ul className=" list-disc ml-16 mt-3">
                          <li>มารดา ได้รับเงินมรดกจำนวน 1/6 ของกองมรดก</li>
                          <li>หลานสาว ได้รับเงิน มรดกจำนวน 1/2 ของกองมรดก</li>
                          <li>พี่สาวที่ร่วมแต่บิดา ได้รับมรดกส่วนเหลือ ซึ่งก็คือ 1- (1/6) - (1/2)=  1/3 ของกองมรดก</li>
                        </ul>
                        เมื่อทำการหาสัดส่วนของทายาทในแต่ละคนได้เป็นที่เรียบร้อย ให้นำเอาส่วนของทายาททั้งหมดมาหา ค.ร.น. โดย ค.ร.น. ที่ได้จากการหาในตัวอย่างข้อนี้ คือ 6
                      </span>
                  </p>
                </li>
                <li> เมื่อคำนวณหา ค.ร.น. จากขั้นตอนที่ 3 เสร็จแล้วให้นำผลลัพธ์ของการหา ค.ร.น. มาหารกับสัดส่วนของทายาทแต่ละประเภทที่ได้กำหนดไว้ในขั้นตอนที่ 2 
                  <p className="ml-8">
                    <span className=" text-blue-600">
                      <ul className=" list-disc ml-10 mt-3">
                        <li>จากขั้นตอนที่ 2 ให้กำหนดสัดส่วนในแต่ละทายาทก่อน โดยในตัวอย่างนี้ 
                          <ul className=" list-disc ml-8 mt-">
                            <li>มารดา ได้รับเงินมรดกจำนวน 1/6 ของกองมรดก</li>
                            <li>หลานสาว ได้รับเงิน มรดกจำนวน 1/2 ของกองมรดก</li>
                            <li>พี่สาวที่ร่วมแต่บิดา ได้รับมรดกส่วนเหลือ ซึ่งก็คือ 1/3 ของกองมรดก</li>
                          </ul>
                        </li>
                        <li>จากนั้นให้นำ ค.ร.น. จากขั้นตอนที่ 3 มาหารกับส่วนในแต่ละสัดส่วนของแต่ละทายาท ดังนี้
                          <ul className=" list-disc ml-8 mt-">
                            <li>มารดา ส่วนของสัดส่วนคือ 6 ส่วนที่ได้รับในกองมรดก = 6/6 = 1  ส่วน</li>
                            <li>หลานสาว ส่วนของสัดส่วนคือ 2 ส่วนที่ได้รับในกองมรดก = 6/2 = 3  ส่วน</li>
                            <li>พี่สาวที่ร่วมแต่บิดา ส่วนของสัดส่วนคือ 3 ส่วนที่ได้รับในกองมรดก = 6/3 = 2  ส่วน</li>
                          </ul>
                        </li>
                      </ul>
                    </span>
                  </p>
                </li>
                <li>นำจำนวนเงินของกองมรดกทั้งหมดมาทำการหารกับผลลัพธ์ของ ค.ร.น. ที่ได้หาไว้ในขั้นตอนที่ 3
                  <p className="ml-8">
                    <span className=" text-blue-600">
                      จากตัวอย่าง เงินมรดกมีทั้งหมด 600,000 บาท นำมาหารกับผลลัพธ์ในขั้นตอนที่ 3 ได้ดังนี้ <br></br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เงินทั้งหมดในกองมรดก/(ผลลัพธ์ค.ร.น.ของส่วนในสัดส่วนทั้งหมด (ขั้นตอนที่ 3)) = 600,000/6 = 100,000 บาท
                    </span>
                  </p>
                </li>
                <li>ขั้นตอนสุดท้ายให้นำอัตราส่วนผลลัพธ์ของทายาทแต่ละคนที่ได้จากขั้นตอนที่ 4 มาทำการคูณกันกับผลลัพธ์ที่ได้จากขั้นตอนที่ 5 ผลลัพธ์สุดท้ายจะทราบว่าทายาทในแต่ละคนของเจ้ามรดกจะได้รับมรดกในจำนวนเงินเท่าไหร่
                <p className="ml-8">
                    <span className=" text-blue-600">
                      <ul className=" list-disc ml-10 mt-3">
                        <li>ผลลัพธ์ที่ได้จากขั้นตอนที่ 4 มีดังนี้
                          <ul className=" list-disc ml-8 mt-">
                          <li>มารดา ส่วนของสัดส่วนคือ 6 ส่วนที่ได้รับในกองมรดก 1 ส่วน</li>
                            <li>หลานสาว ส่วนของสัดส่วนคือ 2 ส่วนที่ได้รับในกองมรดก 3 ส่วน</li>
                            <li>พี่สาวที่ร่วมแต่บิดา ส่วนของสัดส่วนคือ 3 ส่วนที่ได้รับในกองมรดก 2 ส่วน</li>
                          </ul>
                        </li>
                        <li>ผลลัพธ์ที่ได้ขั้นตอนที่ 5 คือ 100,000 บาท</li>
                        <li>ดังนั้นจะได้ว่า
                          <ul className=" list-disc ml-8 mt-">
                            <li>มารดา จะได้รับมรดกจำนวน 100,000 x 1 = 100,000 บาท</li>
                            <li>หลานสาว จะได้รับมรดกจำนวน 100,000 x 3 = 300,000 บาท</li>
                            <li>พี่สาวที่ร่วมแต่บิดา จะได้รับมรดกจำนวน 100,000 x 2 = 200,000 บาท</li>
                          </ul>
                        </li>
                      </ul>
                    </span>
                  </p>
                </li>
              </ul>
            </p>
          </div>{/* 1 */}

          {/* 2  */}
          <div>
            <h2 id="second-header">2. รูปแบบปัญหาการแบ่งมรดก</h2>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;รูปแบบปัญหาการในแบ่งมรดกมี 3 รูปแบบ ดังนี้
              <ul className=" list-decimal ml-16 mb-3">
                <li><b>ปัญหาอาดีละห์ (مسائل عادلة)</b> หมายถึง ปัญหาปกติที่ส่วนของบรรดาทายาทได้รับเท่ากับฐานโจทย์ หรือส่วนเต็มพอดี</li>
                <li><b>ปัญหาอาอีละห์ (مسائل عائلة)</b> หมายถึง ปัญหาที่จำนวนส่วนที่บรรดาทายาทได้รับมากกว่าฐานโจทย์ หรือเรียกว่า (العول) หรือปัญหาเศษเกิน ในกรณีนี้ให้ยึดเอาเศษเกินนั้นเป็นจำนวนเต็ม หรือฐานโจทย์ได้ทันที และส่วนเพิ่มที่เกิดขึ้นได้ในส่วนเต็ม หรือฐานโจทย์มีดังต่อไปนี้ 
                  <ul className=" list-decimal ml-16 mt-3">
                    <li>ส่วนร่วมที่เป็น 6 สามารถเพิ่มตามเศษเกินได้เป็น 7, 8, 9, 10</li>
                    <li>ส่วนร่วมที่เป็น 12 สามารเพิ่มตาามเศษเกินได้เป็น 13, 15, 17</li>
                    <li>ส่วนร่วมที่เป็น 24 สามารถเพิ่มตามเศษเกินได้เป็น 27 </li>
                  </ul>
                </li>
                <li><b>ปัญหากอศีเราะฮฺ (مسائل قاصرة)</b> ปัญหาจำนวนส่วนที่บรรดาทายาทได้รับน้อยกว่าฐานโจทย์ กล่าวคือ เมื่อทายาทกลุ่มผู้รับส่วนกำหนดได้รับมรดกครบถ้วนแล้ว แต่ยังคงมีส่วนแบ่งเหลืออยู่โดยไม่มีผู้รับส่วนเหลือ ให้ปัดมรดกที่เหลือนั้นไปให้ทายาทผู้ที่มีส่วนกำหนดที่แน่นอนในกองมรดกเหล่านั้น ตามสัดส่วนที่แต่ละคนมีสิทธิ ยกเว้นสามีและภรรยา บิดา และปู่</li>
              </ul>
            </p>
          </div>{/* 2  */}

          {/* 3 */}
          <div>
            <h2 id="third-header">3. ฐานโจทย์ หรือส่วนเต็ม หรือส่วนร่วม</h2>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;นักวิชาการมีทรรศนะเห็นพ้องกันว่า ฐานโจทย์ หรือส่วนเต็ม หรือส่วนร่วมมี 7 จำนวน คือ 2, 3, 4, 6, 8, 12, 24
              <p className="ml-16">
                <table className="w-full mt-3">
                  <tr>
                    <th>อัตราส่วน</th>
                    <th>ส่วนเต็ม</th>
                  </tr>
                  <tr>
                    <td>1/2</td>
                    <td>2</td>
                  </tr>
                  <tr>
                    <td>1/3, 2/3</td>
                    <td>3</td>
                  </tr>
                  <tr>
                    <td>1/4, 1/2</td>
                    <td>4</td>
                  </tr>
                  <tr>
                    <td>1/2, 1/3, 2/3, 1/6</td>
                    <td>6</td>
                  </tr>
                  <tr>
                    <td>1/2, 1/4, 1/8</td>
                    <td>8</td>
                  </tr>
                  <tr>
                    <td>1/6, 1/3, 2/3, 1/4, 1/2</td>
                    <td>12</td>
                  </tr>
                  <tr>
                    <td>1/8, 1/6, 1/4, 1/3, 2/3, 1/2</td>
                    <td>24</td>
                  </tr>
                </table>
              </p>
            </p>
          </div>{/* 3 */}

          <div>
            <h2 id="fourth-header">4. การปรับฐานโจทย์ และวิธีการปรับฐานโจทย์</h2>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;การปรับฐานโจทย์ หรือการปรับส่วนเต็ม หรือการปรับส่วนร่วม หมายถึงการปรับตัวเลขที่เป็นฐานโจทย์ หรือที่เป็นส่วนเต็ม โดยการปรับไปหาตัวเลขอีกจำนวนหนึ่งที่เป็นตัวเลขที่น้อยที่สุด 
              ที่สามารถแบ่งได้ลงตัวกับส่วนได้ลงตัวกับส่วนได้ของทายาทแต่ละคนที่ได้รับ โดยไม่มีเศษ แต่ถ้าหากว่าในกรณีที่สามารถแบ่งได้ลงตัวพอดีกับจำนวนของทายาทแต่ละรายที่เป็นผู้มีสิทธิในปัญหานั้นก็ไม่จำเป็นที่จะต้องปรับฐานโจทย์
              <br></br>
              <p className="ml-4">
                <a className="text-indigo underline"><b>วิธีการ และขั้นตอนการปรับฐานโจทย์ หรือปรับส่วนเต็ม</b></a>{" "}
                  <p className="ml-4">
                  <a className="text-indigo underline"><b>ตังอย่างที่ 1</b></a>{" "}ผู้ตายทิ้งมารดา พี่น้องหญิงร่วมแต่มารดา 5 คน และลุง 5 คน พร้อมกับกองมรดกเป็นเงินจำนวน 300,000 บาท 
                    <table className="w-full mt-3">
                      <tr>
                        <th>ทายาท</th>
                        <th>อัตราส่วนที่ได้รับ</th>
                        <th>ฐานโจทย์</th>
                        <th>ส่วนที่ได้รับ</th>
                        <th>ฐานโจทย์ที่ปรับใหม่</th>
                        <th>ส่วนที่ได้รับใหม่</th>
                        <th>จำนวนเงินที่ได้รับใหม่</th>
                      </tr>
                      <tr>
                        <td>มารดา</td>
                        <td>1/6</td>
                        <td rowspan="3">6</td>
                        <td>1</td>
                        <td rowspan="3">30</td>
                        <td>5</td>
                        <td>50,000 บาท</td>
                      </tr>
                      <tr>
                        <td>พี่น้องหญิงร่วมแต่มารดา 5 คน</td>
                        <td>1/3</td>
                        {/* <td>6</td> */}
                        <td>2</td>
                        {/* <td>30</td> */}
                        <td>10</td>
                        <td>100,000 บาท</td>
                      </tr>
                      <tr>
                        <td>ลุง 5 คน</td>
                        <td>ส่วนเหลือ</td>
                        {/* <td>6</td> */}
                        <td>3</td>
                        {/* <td>30</td> */}
                        <td>15</td>
                        <td>150,000</td>
                      </tr>
                    </table>
                  <br></br>
                  โดยในโจทย์นี้มีทายาท 2 กลุ่ม คือ พี่น้องหญิงร่วมแต่มารดา และลุงที่ไม่สามารถแบ่งส่วนรับมรดกให้แก่พวกเขาได้ลงตัว และเป็นสาเหตุของการปรับส่วน
                  ซึ่งวิธีการปรับฐานใหม่มีดังนี้
                    <ul className=" list-decimal ml-12 mb-3">
                      <li>นำจำนวนพี่น้องหญิงร่วมมารดา หรือจำนวนของลุง คือ 5 (เลือกมาอย่างใดอย่างหนึ่ง) นำไปคูนกับฐานโจทย์ คือ 6 ซึ่งขะทำให้ได้ฐานโจทย์ใหม่ คือ 30</li>
                      <li>นำตัวคูณไปคูนกับส่วนได้ของทายาทแต่ละคนที่ได้รับส่วนได้ไปแล้วในตอนแรก -- เช่น มารดาได้รับส่วนเดิม คือ 1 นำไปคูณกับ 5 จะได้ 5/ฐานโจทย์ที่ปรับใหม่ = 5/30</li>
                    </ul>
                  </p>
              </p>
            </p>
          </div>
        </p>
      </div>

      <div>
        <h1 className="ml-4">แนะนำสำหรับคุณ</h1>
        <ul className="list__post">
        <li>
            <a className="text-indigo-700 underline" href="/islam/1">
            ความรู้ทั่วไปของกฎหมายมรดกอิสลาม
            </a>
          </li>
          <li>
            <a className="text-indigo-700 underline" href="/islam/2">
              ทายาทที่มีสิทธิและเสียสิทธิรับมรดก
            </a>
          </li>
          <li>
            <a className="text-indigo-700 underline" href="/islam/4">
              การแบ่งมรดกกรณีพิเศษ
            </a>
          </li>
          <li>
            <a className="text-indigo-700 underline" href="/islam/5">
              บทบัญญัติที่ถูกกล่าวถึงในกฎหมายมรดก
            </a>
          </li>
          <li>
            <a className="text-indigo-700 underline" href="/islam/6">
              พินัยกรรม
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default คำนวณ;
